import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import * as React from "react";
import {library} from "@fortawesome/fontawesome-svg-core";
import {faAlignRight} from "@fortawesome/free-solid-svg-icons/faAlignRight";
import {faAlignLeft} from "@fortawesome/free-solid-svg-icons/faAlignLeft";
import {faAlignCenter} from "@fortawesome/free-solid-svg-icons/faAlignCenter";
import {faBold} from "@fortawesome/free-solid-svg-icons/faBold";
import {faItalic} from "@fortawesome/free-solid-svg-icons/faItalic";
import {PDFControlBase} from "InternalShared/PageBuilder/Controls/Core/PDFControlBase";
import {GroupProperties} from "InternalShared/PageBuilder/Controls/Properties/styles/GroupProperties";
import {DimensionStyleSet} from "InternalShared/PageBuilder/Controls/Properties/StyleSets/DimensionStyleSet";
import {NumberProperty} from "InternalShared/PageBuilder/Controls/Properties/NumberProperty";
import {ColorProperty} from "InternalShared/PageBuilder/Controls/Properties/ColorProperty";
import {ButtonProperties} from "InternalShared/PageBuilder/Controls/Properties/ButtonProperties";
import {AllowedResizeDirection} from "InternalShared/Dto";
import {
    FieldControlOptions,
    LabelPositionEnum
} from "PageBuilder/pagebuilder/Controls/ControlsList/FieldControl.Options";
import {SimpleTextProperty} from "InternalShared/PageBuilder/Controls/Properties/SimpleTextProperty";
import {DropDownProperty} from "InternalShared/PageBuilder/Controls/Properties/DropDownProperty";
import {PDFControlBaseOptions} from "InternalShared/PageBuilder/Controls/Core/PDFControlBase.Options";
import {FontFamilyProperty} from "InternalShared/PageBuilder/Controls/Properties/FontFamilyProperty";
import {PropertyBase} from "InternalShared/PageBuilder/Controls/Properties/PropertyBase";
import {FieldDropdownProperty} from "InternalShared/PageBuilder/Controls/Properties/FieldDropdownProperty";
import {faUnderline} from "@fortawesome/free-solid-svg-icons/faUnderline";
import {CustomFieldControlOptions} from "PageBuilder/pagebuilder/Controls/ControlsList/CustomFieldControl.Options";


library.add(faAlignRight);
library.add(faAlignLeft);
library.add(faAlignCenter);
library.add(faBold);
library.add(faItalic);
library.add(faUnderline);
declare let rednaoPDFInvoiceParams:any;
export class CustomFieldControl extends PDFControlBase{


    GetStyles(): GroupProperties[] {

            return [
                DimensionStyleSet.GetStyles(this),
                new GroupProperties('Label Styles')
                    .AddProperties([
                        new FontFamilyProperty(this,'font-family',this.StyleManager.CreateStyleClassManager('.FieldLabel p')).SetLabel('Font Family'),
                        new NumberProperty(this,'font-size',this.StyleManager.CreateStyleClassManager('.FieldLabel p')).SetLabel('Font Size').SetPlaceholder('Default'),
                        new ColorProperty(this,'color',this.StyleManager.CreateStyleClassManager('.FieldLabel p')).SetLabel('Font Color'),
                        new ButtonProperties(this,'text-align',this.StyleManager.CreateStyleClassManager('.FieldLabel p')).SetLabel('Alignment')
                            .AddButton('left',<FontAwesomeIcon icon={"align-left"}/>)
                            .AddButton('center',<FontAwesomeIcon icon={"align-center"}/>)
                            .AddButton('right',<FontAwesomeIcon icon={"align-right"}/>),
                        new ButtonProperties(this,'text-align',this.StyleManager.CreateStyleClassManager('.FieldLabel p')).SetLabel('Styles').AllowMultiple()
                            .AddButton('normal',<FontAwesomeIcon icon={"bold"}/>,'font-weight',true)
                            .AddButton('italic',<FontAwesomeIcon icon={"italic"}/>,'font-style')
                    ]),
                new GroupProperties('Value Styles')
                    .AddProperties([
                        new FontFamilyProperty(this,'font-family',this.StyleManager.CreateStyleClassManager('.FieldValue p')).SetLabel('Font Family'),
                        new NumberProperty(this,'font-size',this.StyleManager.CreateStyleClassManager('.FieldValue p')).SetLabel('Font Size').SetPlaceholder('Default'),
                        new ColorProperty(this,'color',this.StyleManager.CreateStyleClassManager('.FieldValue p')).SetLabel('Font Color'),
                        new ButtonProperties(this,'text-align',this.StyleManager.CreateStyleClassManager('.FieldValue p')).SetLabel('Alignment')
                            .AddButton('left',<FontAwesomeIcon icon={"align-left"}/>)
                            .AddButton('center',<FontAwesomeIcon icon={"align-center"}/>)
                            .AddButton('right',<FontAwesomeIcon icon={"align-right"}/>),
                        new ButtonProperties(this,'text-align',this.StyleManager.CreateStyleClassManager('.FieldValue p')).SetLabel('Styles').AllowMultiple()
                            .AddButton('bold',<FontAwesomeIcon icon={"bold"}/>,'font-weight')
                            .AddButton('italic',<FontAwesomeIcon icon={"italic"}/>,'font-style')
                            .AddButton('1px solid black',<FontAwesomeIcon icon={"underline"}/>,'border-bottom')
                    ])


            ];
    }
    public AllowedResizeDirection:AllowedResizeDirection="both";
    public Options:FieldControlOptions;
    private properties:GroupProperties[];


    protected InternalGetLabel(): string {
        return this.Options.Label;
    }

    public NeedTranslations(): boolean {
        return true;
    }

    public GetTranslatedText(): any {
        return {text:''};
    }

    protected InternalGenerateHtml($container: JQuery) {

        let textToUse='';
        if(this.Options.FieldId=='') {
            let text=document.createElement('p');
            text.innerText = '#Please select a field';
            $container.append(text);
        }
        else
        {
            let field=this.Page.CustomFields.find(x=>x.Id==this.Options.FieldId);
            if(field==null)
            {
                let text=document.createElement('p');
                text.style.color='red';
                text.style.fontStyle='bold';
                text.innerText='Invalid field!';
                text.title='Looks like this field does not exist anymore in your form. Please select another.'
                $container.append(text);
            }else{
               this.CreateLabel($container,field);
            }

        }

        
    }


    GetValueEditor(): PropertyBase {
        return new FieldDropdownProperty(this,"FieldId").SetFormId(this.Page!=null?this.Page.Form.Id:'').SetLabel('');
    }

    public GetProperties(): GroupProperties[] {
        if(this.properties==null)
        {
            let fields=new DropDownProperty(this,'FieldId').SetLabel('Field').Focus();
            let labelProperty=new SimpleTextProperty(this,'Label').SetLabel("Label").SetDisabled(this.Options.FieldId=='');
            let labelPositionProperty=new DropDownProperty(this,'LabelPosition').SetLabel("Label Position").SetDisabled(this.Options.FieldId=='').OnChange(e=>this.PositionChanged())
                .AddOption('Top',LabelPositionEnum.Top.toString())
                .AddOption('Bottom',LabelPositionEnum.Bottom.toString())
                .AddOption('Left',LabelPositionEnum.Lef.toString())
                .AddOption('Righ',LabelPositionEnum.Right.toString());

            for(let field of this.Page.CustomFields)
            {
                fields.AddOption(field.Name+' (Id: '+field.Id+')' ,field.Id);
            }
            this.properties=[new GroupProperties('General')
                .AddProperties([
                    fields,
                    labelProperty,
                    labelPositionProperty
                ])];


            fields.OnChange(()=>{
                this.Options.Label=this.Page.CustomFields.find(x=>x.Id==this.Options.FieldId).Name;
                labelProperty.SetDisabled(this.Options.FieldId=='');
                labelPositionProperty.SetDisabled(this.Options.FieldId=='');
            });
        }

        return this.properties;
    }


    public AfterRefresh() {
        let height:number=this.$element.find('.elementContent').height();
        this.$element.velocity('stop',true);
        this.$element.velocity(200,"easeInExp");

    }

    GetInitialOptions(): Promise<PDFControlBaseOptions> {
        return new Promise(resolve => {
            resolve(new CustomFieldControlOptions().Merge());
        });
    }

    private CreateLabel($container: JQuery,field:{Name:string,Id:string}) {
        let text=document.createElement('p');
        text.innerText='#'+field.Name+' (Id:'+field.Id+')';

        let table=document.createElement('table');
        $container.append(table);
        let body=document.createElement('tbody');
        table.append(body);

        let textColumn=document.createElement('td');
        textColumn.className='FieldValue';
        textColumn.append(text);

        let row;
        let column;
        if(this.Options.Label=='')
        {
            row=document.createElement('tr');
            body.append(row);
            row.append(textColumn);

        }else
        {


            let labelColumn=document.createElement('td');
            labelColumn.className='FieldLabel';
            let label=document.createElement('p');
            label.innerText=this.Options.Label;
            labelColumn.append(label);


            switch (this.Options.LabelPosition) {
                case LabelPositionEnum.Top:
                    label.classList.add('Top');
                    row=document.createElement('tr');
                    body.append(row);
                    row.append(labelColumn);

                    row=document.createElement('tr');
                    body.append(row);
                    row.append(textColumn);


                    break;
                case LabelPositionEnum.Bottom:
                    label.classList.add('Bottom');
                    row=document.createElement('tr');
                    body.append(row);
                    row.append(textColumn);

                    row=document.createElement('tr');
                    body.append(row);
                    row.append(labelColumn);
                    break;
                case LabelPositionEnum.Lef:
                    label.classList.add('Left');
                    row=document.createElement('tr');
                    body.append(row);

                    row.append(labelColumn);
                    row.append(textColumn);
                    break;
                case LabelPositionEnum.Right:
                    label.classList.add('Right');
                    row=document.createElement('tr');
                    body.append(row);

                    row.append(textColumn);
                    row.append(labelColumn);
                    break;
            }
            


        }

    }

    private PositionChanged() {
        if(this.Options.LabelPosition==LabelPositionEnum.Lef)
        {
            this.StyleManager.AddStyleSet('.FieldValue',{width:'100%'});
            this.StyleManager.AddStyleSet('.FieldValue p',{'margin-left':'2px'});
            this.StyleManager.AddStyleSet('.FieldLabel',{'white-space':'nowrap'});
        }else{
            this.StyleManager.AddStyleSet('.FieldValue p',{'margin-left':''});
            this.StyleManager.AddStyleSet('.FieldLabel',{'white-space':''});
        }
        this.Refresh();
    }
}


